<template>
  <div class="col-sm-12 nopads pt-2">
    <Transition name="fade">
      <keep-alive>
        <street-light-search
          :user="user"
          @search="fetchStreetLights"
        />
      </keep-alive>
    </Transition>
    <Transition name="fade">
      <div class="col-sm-12">
        <div
          class="button-container col-sm-12 trip-buttons"
        >
          <button
            class="btn  btn-outline-primary form-button"
            :disabled="loading"
            @click="importFromFile"
          >
            {{ $t('common.import_from_file') }}
          </button>
          <button
            v-if="results.length > 0"
            :disabled="results.length < 1"
            class="btn  btn-outline-success form-button"
            @click="exportExcel"
          >
            {{ $t('trip.download_excel') }}
          </button>
        </div>
        <street-light-list
          :street-lights="results"
          @row-clicked="editStreetLight"
        />
      </div>
    </Transition>

    <street-light-wizard
      v-if="streetLight != null"
      :street-light="streetLight"
      @close="streetLight=null"
      @close-and-update="closeAndUpdate"
    />

    <street-light-importer
      v-if="showFileImporter"
      @close="showFileImporter = false"
    />

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import {downloadHelper} from "../mixins/DownloadMixin";
import StreetLightSearch from "@/components/streetlights/StreetLightSearch";
import StreetLightList from "@/components/streetlights/StreetLightList";
import StreetLightWizard from "@/components/streetlights/StreetLightWizard";
import StreetLightImporter from "@/components/streetlights/StreetLightImporter";
import {inject} from "vue";

export default {
    name: 'StreetLights',
    components: {StreetLightImporter, StreetLightWizard, StreetLightList, StreetLightSearch},
    mixins: [restApi, downloadHelper],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            results: [],
            streetLight: null,
            loading: false,
            lastSearchedParams: null,
            showFileImporter: false
        }
    },

    methods: {
        fetchStreetLights: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.streetLightUrl, this.lastSearchedParams, this.handleSearch, () => {
                this.loading = false
            })
        },
        handleSearch: function (response) {
            this.results = response.data
            this.loading = false
        },
        editStreetLight: function (streetLight) {
            this.streetLight = this.results.find(item => item.id === streetLight.id)
        },
        closeAndUpdate: function () {
            this.streetLight = null
            this.fetchStreetLights(this.lastSearchedParams)
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.streetLightXlsxUrl, this.getCommonReportParams(this.lastSearchedParams), this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('street_lights.report_file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
        importFromFile() {
            this.showFileImporter = true
        },
        hideFileImporter() {
            this.showFileImporter = false
            this.fetchStreetLights(this.lastSearchedParams)
        }
    }
}
</script>
